/* eslint-disable react/prop-types */ // TODO: add props
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import Immutable from 'immutable';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import style from './Sidebar.scss';
import chunkGroupClassNames from 'edrolo/utils/chunkGroupClassNames';

const IconActivity = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.6 8.2C0.434315 8.42091 0.479086 8.73431 0.7 8.9C0.920914 9.06569 1.23431 9.02091 1.4 8.8L0.6 8.2ZM4 4.5L4.35355 4.14645C4.25106 4.04395 4.10914 3.99098 3.96456 4.00126C3.81997 4.01153 3.68697 4.08404 3.6 4.2L4 4.5ZM6.5 7L6.14645 7.35355C6.24786 7.45496 6.38793 7.50795 6.53107 7.49903C6.67421 7.49012 6.80663 7.42018 6.89468 7.30697L6.5 7ZM10.3947 2.80697C10.5642 2.589 10.5249 2.27486 10.307 2.10532C10.089 1.93579 9.77486 1.97506 9.60532 2.19303L10.3947 2.80697ZM1.4 8.8L4.4 4.8L3.6 4.2L0.6 8.2L1.4 8.8ZM3.64645 4.85355L6.14645 7.35355L6.85355 6.64645L4.35355 4.14645L3.64645 4.85355ZM6.89468 7.30697L10.3947 2.80697L9.60532 2.19303L6.10532 6.69303L6.89468 7.30697Z" />
  </svg>
);

const Chunk = ({
  chunk,
  visited,
  active,
  className,
  onClick,
  buildChunkUrl,
}) => (
  <li
    className={cx(
      style.chunk,
      {
        [style.visitedChunk]: visited,
        [style.activeChunk]: active,
        [style.hasQuestion]: !!chunk.get('question'),
        [style.hasActivity]: !!chunk.get('activity'),
        'data-test-active': active,
      },
      className
    )}
    key={chunk.get('id')}
  >
    <Link
      to={buildChunkUrl(chunk.get('index'))}
      className={style.chunkTitle}
      onClick={onClick}
      title={chunk.get('title')}
    >
      {!!chunk.get('activity') && <IconActivity />}
      {chunk.get('title')}
    </Link>
  </li>
);

const Sidebar = ({
  lesson,
  activeIndex,
  visitedChunkIds,
  closeSidebar,
  hideChunkNav,
  buildChunkUrl,
  renderTopNav = () => null,
}) => {
  const showChunkNav = !hideChunkNav;
  return (
    <div>
      {renderTopNav()}
      <h2 className={style.lessonTitle}>{lesson.get('title')}</h2>
      <ul className={style.sidebar} data-test="sidebar-chunk-list">
        {showChunkNav &&
          lesson
            .get('chunks', Immutable.List())
            .map((chunk, i, chunks) => {
              const nextChunk = chunks.get(i + 1);
              const groupingClasses = chunkGroupClassNames(chunk, nextChunk);
              return (
                <Chunk
                  key={chunk.get('id')}
                  chunk={chunk}
                  buildChunkUrl={buildChunkUrl}
                  active={chunk.get('index') === Number(activeIndex)}
                  visited={visitedChunkIds.includes(chunk.get('id'))}
                  className={groupingClasses}
                  onClick={closeSidebar}
                />
              );
            })
            .toJS()}
      </ul>
    </div>
  );
};

const ChunkPropType = IPT.contains({
  id: PT.number.isRequired,
  title: PT.string.isRequired,
  index: PT.number.isRequired,
  question: PT.object,
});

const LessonPropType = IPT.contains({
  id: PT.number,
  title: PT.string,
  chunks: IPT.listOf(ChunkPropType),
});

Sidebar.propTypes = {
  lesson: LessonPropType,
  activeIndex: PT.string,
  visitedChunkIds: IPT.listOf(PT.number),
  hideChunkNav: PT.bool,
  closeSidebar: PT.func,
  buildChunkUrl: PT.func.isRequired,
  renderTopNav: PT.func,
};

Sidebar.defaultProps = {
  visitedChunkIds: Immutable.List(),
  renderTopNav: () => null,
};

export default Sidebar;
